import React, { useState } from 'react';
import { Box, Heading, SimpleGrid, Text, VStack, Button, HStack, Icon } from '@chakra-ui/react';
import { FaPaintBrush, FaCode, FaBug, FaUserTie, FaBriefcase, FaSearch, FaArrowRight } from 'react-icons/fa';

const categories = [
  {
    icon: '/png/ui-icon.png',
    title: 'UI/UX Design',
    jobs: 2,
  },
  {
    icon: '/png/development.png',
    title: 'Development',
    jobs: 10,
  },
  {
    icon: '/png/sqa-icon.png',
    title: 'SQA',
    jobs: 0,
  },
  {
    icon: '/png/hr-icon.png',
    title: 'HR Admin',
    jobs: 1,
  },
  {
    icon: '/png/marketing-icon.png',
    title: 'Marketing',
    jobs: 2,
  },
  {
    icon: '/png/seo-icon.png',
    title: 'SEO',
    jobs: 3,
  },
];

const MostDemandingCategories = () => {
  const [activeIdx, setActiveIdx] = useState(2); // SQA active by default

  return (
    <Box pb={{ base: 6, md: 12 }} px={{ base: 1, md: 0 }}>
      <Heading
        as="h2"
        fontSize={{ base: 'xl', md: '2xl', lg: '3xl' }}
        textAlign="center"
        mb={{ base: 6, md: 10 }}
        color="#244034"
        fontWeight="bold"
        letterSpacing="-1px"
      >
        Most Demanding <span style={{ color: '#234F1E' }}>Categories</span>
      </Heading>
      <SimpleGrid columns={{ base: 1, sm: 2, md: 3, lg: 6 }} spacing={{ base: 3, md: 6 }} maxW="7xl" mx="auto">
        {categories.map((cat, idx) => {
          const isActive = idx === activeIdx;
          return (
            <Box
              key={cat.title}
              border="1px solid #B2BEB5"
              borderRadius="2xl"
              py={{ base: 4, md: 8 }}
              px={{ base: 1, md: 2 }}
              bg={isActive ? '#215560' : 'white'}
              textAlign="center"
              boxShadow="sm"
              cursor="pointer"
              transition="all 0.2s"
              _hover={{
                bg: '#215560',
                borderColor: '#234F1E',
                boxShadow: 'md',
              }}
              onMouseEnter={() => setActiveIdx(idx)}
            >
              <VStack spacing={{ base: 2, md: 3 }}>
                {typeof cat.icon === "string" ? (
                  <img
                    src={cat.icon}
                    alt={cat.title}
                    style={{
                      width: "36px",
                      height: "36px",
                      objectFit: "contain",
                      filter: isActive ? "brightness(1.2)" : "none"
                    }}
                  />
                ) : (
                  <Icon
                    as={cat.icon}
                    boxSize={{ base: 7, md: 9 }}
                    color={isActive ? '#ffff00' : '#215560'}
                    _groupHover={{ color: '#ffff00' }}
                  />
                )}
                <Text
                  fontWeight="bold"
                  fontSize={{ base: 'md', md: 'lg' }}
                  color={isActive ? '#ffff00' : '#2F4F4F'}
                  letterSpacing="-0.5px"
                >
                  {cat.title}
                </Text>
                <Text color={isActive ? '#ffff00' : 'gray.600'} fontSize={{ base: 'sm', md: 'md' }}>
                  {cat.jobs} Jobs
                </Text>
              </VStack>
            </Box>
          );
        })}
      </SimpleGrid>
      <HStack justify="center" mt={{ base: 5, md: 10 }} spacing={{ base: 2, md: 4 }}>
        <Button
          variant="outline"
          borderRadius="full"
          px={{ base: 4, md: 6 }}
          py={{ base: 1, md: 2 }}
          fontWeight="bold"
          fontSize={{ base: 'sm', md: 'lg' }}
          color="#2F4F4F"
          borderColor="#D1D5DB"
          bg="#F7F8FF"
          _hover={{ bg: '#E6E8F5', borderColor: '#234F1E', color: '#234F1E' }}
        >
          See more
        </Button>
        <Button
          borderRadius="full"
          colorScheme="green"
          bg="#234F1E"
          minW={{ base: 8, md: 10 }}
          minH={{ base: 8, md: 10 }}
          p={0}
          _hover={{ bg: '#1A3A15' }}
        >
          <FaArrowRight color="white" />
        </Button>
      </HStack>
    </Box>
  );
};

export default MostDemandingCategories; 